import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  	selector: 'app-filters-edit',
  	standalone: true,
  	imports: [
    	MatFormFieldModule,
		MatIconModule,
		ReactiveFormsModule,
		MatInputModule,
		MatButtonModule,
		FormsModule,
		MatCheckboxModule
  	],
  	templateUrl: './filters-edit.component.html',
  	styleUrl: './filters-edit.component.scss'
})
export class FiltersEditComponent implements OnInit {
  	filtersEditFrom: FormGroup = this._fb.group({});

	showPassword = {
		old: false,
		new: false,
		reit: false
	};

  	constructor(private _fb: FormBuilder) {}

  	ngOnInit(): void {
		this._formBuilder();
		this._setDynamicFieldsFilters();
	}

  	onSubmit(): void {
		console.log(this.filtersEditFrom.value);
	}

  	private _formBuilder(): void {
		this.filtersEditFrom = this._fb.group({
			old: ['', Validators.required],
			new: [{value: '', disabled: true}, Validators.required],
			reit: [{value: '', disabled: true}, Validators.required]
		});
	}

	private _setDynamicFieldsFilters(): void {
		this.filtersEditFrom.get('old')?.valueChanges.subscribe((value) => {
			if (value) {
				this.filtersEditFrom.get('new')?.enable();
			} else {
				this.filtersEditFrom.get('new')?.setValue('');
				this.filtersEditFrom.get('new')?.disable();
				this.filtersEditFrom.get('reit')?.setValue('');
				this.filtersEditFrom.get('reit')?.disable();
			}
		});
	
		this.filtersEditFrom.get('new')?.valueChanges.subscribe((value) => {
			if (value) {
				this.filtersEditFrom.get('reit')?.enable();
			} else {
				this.filtersEditFrom.get('reit')?.setValue('');
				this.filtersEditFrom.get('reit')?.disable();
			}
		});
	}

	togglePasswordVisibility(field: 'old' | 'new' | 'reit', state: boolean): void {
		this.showPassword[field] = state;
	}
}
